import TableDsBenhNhanKhamBenh from "./TableDsBenhNhanKhamBenh";

export const DSBenhNhanKhamBenh = (props:any) => {
  const { filter, setFilter } = props;
  return (
    <div className="bangDSBenhNhan p-0 position-relative">
      <div className="flex-1 flex flex-column spaces pt-10">
          <TableDsBenhNhanKhamBenh
            statusChangedEvent={props.statusChangedEvent}
            filter={filter}
            setFilter={setFilter}
          />
      </div>
    </div>
  );
};

export default DSBenhNhanKhamBenh;
